/*  dynamicn -> dnm  */
export const dnmCategoryMap = new Map([
  ["paper", "文章"],
  ["patent", "专利"],
  ["activity", "活动"],
  ["recruit", "招募"],
  ["scholar","说说"]
]);
export const dnmTagColorMap = new Map([
  ["文章", "#947dfe"],
  ["专利", "#e0bc7e"],
  ["活动", "#fc9b20"],
  ["招募", "#1aaaf1"],
  ["说说","#0dd6b5"]
]);
// /* component -> comp */
// export const dnmNamePubCompMap = new Map([
//   ["文章", "pub-paper"],
//   ["专利", "pub-patent"],
//   ["活动", "pub-patent"], // 活动和专利共用一个
//   ["招募", "pub-recruit"],
// ]);

export const dnmPubCompMap = new Map([
  ["paper", "pub-paper"],
  ["patent", "pub-patent"],
  ["activity", "pub-activity"], // 活动和专利共用一个
  ["recruit", "pub-recruit"],
  ["scholar", "pub-scholar"],
]);

export const dnmDetailCompMap = new Map([
  ["paper", "paper-detail"],
  ["patent", "patent-detail"],
  ["activity", "patent-detail"], // 活动和专利共用一个
  ["recruit", "recruit-detail"],
  ["scholar", "scholar-detail"],
]);
/*  动态筛选枚举  */
export const categoryEnumList = [
  { name: "全部", value: "全部" },
  { name: "文章", value: "文章" },
  { name: "专利", value: "专利" },
  { name: "活动", value: "活动" },
  { name: "招募", value: "招募" },
  { name: "说说", value: "说说" },
];
export const categoryMap = new Map([
  ["文章", "paper"],
  ["专利", "patent"],
  ["活动", "activity"],
  ["招募", "recruit"],
  ["说说", "scholar"],
]);
